<template>
  <div class="main-tab__heading" v-on="$listeners">
    <h2 v-if="title" class="dea-heading--medium__l dea-text--left">{{ title }}</h2>
    <InputSelect id="interest-courses" name="interest-courses">
      <option value="default" selected>filtra per tipologia corso</option>
      <option v-for="(typology, objKey) in types" :key="objKey" :value="objKey">
        {{ typology }}
      </option>
    </InputSelect>
  </div>
</template>
<script>
import InputSelect from "@/components/elements/InputSelect";

export default {
  name: "PreRegistrationsHeader",
  components: { InputSelect },
  props: {
    title: {
      type: String,
      default: "",
    },
    types: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
